import styled from "styled-components";
import StyledSingleVideo from "../SingleVideo/SingleVideo-styles";

const StyledList = styled.section`
	display: flex;
	margin: auto;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-auto-flow: row dense;
	grid-gap: 2em;

	.my-dropdown-slidedown {
		grid-column: 1 / -1;
	}

	@media (max-width: 1100px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 991px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}

	${StyledSingleVideo} {
	}
`;

export default StyledList;
